var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68752 23C1.50828 23 1.33235 22.9295 1.20142 22.7986C1.01612 22.6133 0.952331 22.338 1.03692 22.0903L2.5603 17.6336C1.53845 15.9249 1 13.9846 1 12C1 5.93471 5.93471 1 12 1C18.0653 1 23 5.93471 23 12C23 18.0653 18.0653 23 12 23C10.0154 23 8.07506 22.4615 6.36639 21.4397L1.90974 22.963C1.83723 22.9879 1.76201 23 1.68752 23ZM6.45167 19.9962C6.58126 19.9962 6.71017 20.0331 6.82227 20.1043C8.37655 21.0993 10.1671 21.625 12 21.625C17.3073 21.625 21.625 17.3073 21.625 12C21.625 6.69267 17.3073 2.37499 12 2.37499C6.69272 2.37499 2.37499 6.69267 2.37499 12C2.37499 13.8329 2.90068 15.6235 3.8957 17.1777C4.00849 17.3543 4.03467 17.5725 3.96689 17.7706L2.79129 21.2087L6.22944 20.0331C6.30195 20.0083 6.37713 19.9962 6.45167 19.9962Z",
    fill: "#B1B5C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.6,
    cy: 12.0004,
    r: 1.1,
    fill: "#B1B5C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0004,
    cy: 12.0004,
    r: 1.1,
    fill: "#B1B5C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4008,
    cy: 12.0004,
    r: 1.1,
    fill: "#B1B5C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.101503f725a1d15c97005a2963f71363.svg";
export { ForwardRef as ReactComponent };